<template>
  <div>
    <lottie
      :options="defaultOptions"
      :height="140"
      :width="140"
      v-on:animCreated="handleAnimation"
    />
    <ul>
      <li @click="play">play</li>
      <li @click="stop">stop</li>
      <li @click="pause">pause</li>
      <li @click="onSpeedChange">加快</li>
      <li @click="setDirection">反向播放</li>

      <li @click="gotoandStop">gotoandStop</li>
    </ul>
  </div>
</template>

<script>
import Lottie from "../Common/lottie.vue";
import * as animationData from "../../assets/pinjump.json";

export default {
  name: "lottie1",
  components: {
    lottie: Lottie
  },
  data() {
    return {
      defaultOptions: { animationData: animationData },
      animationSpeed: 16
    };
  },
  methods: {
    handleAnimation: function(anim) {
      this.anim = anim;
    },
    stop: function() {
      this.anim.stop();
    },
    play: function() {
      this.anim.play();
    },
    pause: function() {
      this.anim.pause();
      // 暂停开始基本可以做到每帧都暂停
    },
    onSpeedChange: function() {
      this.animationSpeed++;
      this.anim.setSpeed(this.animationSpeed);
    },
    setDirection() {
      this.anim.setDirection(-1);
      // 1正向播放
      // 反向
    },
    gotoandStop() {
      this.anim.goToAndStop(1000, true);
      // 直接跳到某一帧,实现一些步骤的动画
      // 第一个值是基于时间的.true
      // 第一个值是基于帧的:false
    },
    gotoandplay() {
      this.anim.gotoAndPlay(100);
    }
  },
  mounted() {
    // this.anim.addEventListener("complete", () => {
    //   console.log("动画播放完毕");
    // });
    // // 嗅探动画发生的事件
    // this.anim.addEventListener("");
  }
};
</script>